import { Formik } from "formik";

import { useChangePasswordMutation } from "@sso/apis/resetPassword";
import { FormikPasswordInput, FormikTextInput } from "@sso/components/Formik";
import { CheckDirtyForm } from "@sso/components/Formik/ChackDirtyForm";
import { SubmitLoadingButton } from "@sso/components/SubmitLoadingButton";
import { AuthKeys } from "@sso/constant";
import { changePasswordInitialValues } from "@sso/constant";
import { ChangePasswordType } from "@sso/types";
import { CustomForm } from "@sso/ui/CustomForm";
import { Flex, GridItem } from "@sso/ui/FlexBox";

import { changePasswordValidation } from "./schema";

export const ChangePassword = () => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const handleOnSubmit = (values: ChangePasswordType) => {
    changePassword(values);
  };

  return (
    <Formik
      initialValues={changePasswordInitialValues}
      validationSchema={changePasswordValidation}
      onSubmit={handleOnSubmit}
    >
      <CustomForm>
        <Flex wrap="wrap" align="baseline" padding="2rem 0 1rem 0" maxWidth="700px">
          <GridItem xs={12} sm={8}>
            <FormikPasswordInput name={AuthKeys.OLD_PASSWORD} label="Old Password" />
          </GridItem>
          <GridItem xs={12} sm={8}>
            <FormikPasswordInput name={AuthKeys.NEW_PASSWORD} label="New Password" showPasswordStrength />
          </GridItem>
          <GridItem xs={12} sm={8}>
            <FormikTextInput name={AuthKeys.CONFIRM_PASSWORD} label="Confirm New Password" type="password" />
          </GridItem>
          <GridItem xs={12} sm={6} width="100%">
            <SubmitLoadingButton loading={isLoading} buttonTitle="Change" />
          </GridItem>
        </Flex>
        <CheckDirtyForm initialValues={changePasswordInitialValues} isDataLoading={isLoading} />
      </CustomForm>
    </Formik>
  );
};
